import RouteEnum from '~/enums/RouteEnum';
var routeEnumPlugin = function routeEnumPlugin(_context, inject) {
  inject('RouteEnum', RouteEnum);
};
export default routeEnumPlugin;